import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "@mui/material";

const ExcelDownload = ({ finalData, notNeededColumn, headerMapping }) => {
  const convertToExcel = () => {
    // Filter out unnecessary columns
    const dataWithoutNotNeededKeys = notNeededColumn.length > 0
      ? finalData.map(item => {
          const filteredItem = {};
          for (const key in item) {
            if (item.hasOwnProperty(key) && !notNeededColumn.includes(key)) {
              filteredItem[key] = item[key];
            }
          }
          return filteredItem;
        })
      : finalData;

    // Map data to use labels from headerMapping
    const mappedData = dataWithoutNotNeededKeys.map(item => {
      const newItem = {};
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          newItem[headerMapping[key] || key] = item[key]; // Use label if available, otherwise fallback to original key
        }
      }
      return newItem;
    });

    // Create a worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(mappedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write the workbook to a binary string
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Create a Blob and download the file
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "data.xlsx");
  };
  
  return (
    <div>
      <Button
      id="stdMastersEQPList_convertexcel"
        variant="contained"
        size="small"
        // sx={{ m: 0,  }}
        style={{ marginLeft: "10px", height: "40px" }}
        onClick={convertToExcel}
      >
     Export into Excel
      </Button>
    </div>
  );
};

export default ExcelDownload;
